/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../infra/hooks';
import { leavesService } from '../../../../api/services/leavesService';
import {
  setAllLeaveApplied,
  setRefreshLeaveApplied,
} from '../../../../infra/aggregates/myProfile/leavesAggregates/leaveAppliedSlice';

interface PropsValues {
  setLeaveAppliedData: (data: any) => void;
  typeFilter: string;
}

function DTOLeaveApplied({ setLeaveAppliedData, typeFilter }: PropsValues) {
  const selector = useAppSelector((state) => state.authSlice);
  const leaveApplied = useAppSelector(
    (state) => state.leaveAppliedSlice.leaveApplied,
  );
  const refetch = useAppSelector((state) => state.leaveAppliedSlice.refetch);

  const dispatch = useAppDispatch();
  async function getEmployeeAppliedLeaves(
    companyId: number,
    empId: number,
    typeFilter: string,
  ) {
    dispatch(setRefreshLeaveApplied(true));
    const response = await leavesService.getEmployeeAppliedLeaves(
      companyId,
      empId,
      typeFilter,
    );
    if (response) {
      dispatch(setRefreshLeaveApplied(false));

      dispatch(setAllLeaveApplied(response.data));
      return setLeaveAppliedData(response.data);
    } else {
      dispatch(setRefreshLeaveApplied(false));
    }
  }
  useEffect(() => {
    if (selector.emp_id && selector.company_id)
      getEmployeeAppliedLeaves(
        selector.company_id,
        selector.emp_id,
        typeFilter,
      );
  }, [typeFilter, refetch]);

  useEffect(() => {
    setLeaveAppliedData(leaveApplied);
  }, [leaveApplied, refetch]);

  return <></>;
}
export default DTOLeaveApplied;
